// Mask characters (spaces, parens, dash, '*') are ignored — only real digits are counted.
export const countDigitsBefore = (value: string, index: number): number =>
  (value.slice(0, index).match(/\d/g) ?? []).length

// Keeps the caret after the same digit the user was at, however the formatting shifted.
export const caretPositionForDigitCount = (formatted: string, digitCount: number): number => {
  if (digitCount <= 0) return 0
  let seen = 0
  for (let i = 0; i < formatted.length; i++) {
    if (/\d/.test(formatted[i])) {
      seen++
      if (seen === digitCount) return i + 1
    }
  }
  return formatted.length
}
